export const COUNTRIES = [
  { name: "Canada", flag: "🇨🇦", code: "CA", dialCode: "1", minPhoneLength: 10 },
  { name: "United States", flag: "🇺🇸", code: "US", dialCode: "1", minPhoneLength: 10 },
  { name: "Afghanistan", flag: "🇦🇫", code: "AF", dialCode: "93", minPhoneLength: 9 },
  { name: "Åland Islands", flag: "🇦🇽", code: "AX", dialCode: "358", minPhoneLength: 6 },
  { name: "Albania", flag: "🇦🇱", code: "AL", dialCode: "355", minPhoneLength: 9 },
  { name: "Algeria", flag: "🇩🇿", code: "DZ", dialCode: "213", minPhoneLength: 9 },
  { name: "American Samoa", flag: "🇦🇸", code: "AS", dialCode: "1684", minPhoneLength: 7 },
  { name: "Andorra", flag: "🇦🇩", code: "AD", dialCode: "376", minPhoneLength: 6 },
  { name: "Angola", flag: "🇦🇴", code: "AO", dialCode: "244", minPhoneLength: 9 },
  { name: "Anguilla", flag: "🇦🇮", code: "AI", dialCode: "1264", minPhoneLength: 10 },
  { name: "Antarctica", flag: "🇦🇶", code: "AQ", dialCode: "672", minPhoneLength: 0 },
  { name: "Antigua and Barbuda", flag: "🇦🇬", code: "AG", dialCode: "1268", minPhoneLength: 10 },
  { name: "Argentina", flag: "🇦🇷", code: "AR", dialCode: "54", minPhoneLength: 10 },
  { name: "Armenia", flag: "🇦🇲", code: "AM", dialCode: "374", minPhoneLength: 8 },
  { name: "Aruba", flag: "🇦🇼", code: "AW", dialCode: "297", minPhoneLength: 7 },
  { name: "Australia", flag: "🇦🇺", code: "AU", dialCode: "61", minPhoneLength: 9 },
  { name: "Austria", flag: "🇦🇹", code: "AT", dialCode: "43", minPhoneLength: 10 },
  { name: "Azerbaijan", flag: "🇦🇿", code: "AZ", dialCode: "994", minPhoneLength: 9 },
  { name: "Bahamas", flag: "🇧🇸", code: "BS", dialCode: "1242", minPhoneLength: 10 },
  { name: "Bahrain", flag: "🇧🇭", code: "BH", dialCode: "973", minPhoneLength: 8 },
  { name: "Bangladesh", flag: "🇧🇩", code: "BD", dialCode: "880", minPhoneLength: 10 },
  { name: "Barbados", flag: "🇧🇧", code: "BB", dialCode: "1246", minPhoneLength: 10 },
  { name: "Belarus", flag: "🇧🇾", code: "BY", dialCode: "375", minPhoneLength: 9 },
  { name: "Belgium", flag: "🇧🇪", code: "BE", dialCode: "32", minPhoneLength: 9 },
  { name: "Belize", flag: "🇧🇿", code: "BZ", dialCode: "501", minPhoneLength: 7 },
  { name: "Benin", flag: "🇧🇯", code: "BJ", dialCode: "229", minPhoneLength: 8 },
  { name: "Bermuda", flag: "🇧🇲", code: "BM", dialCode: "1441", minPhoneLength: 10 },
  { name: "Bhutan", flag: "🇧🇹", code: "BT", dialCode: "975", minPhoneLength: 8 },
  {
    name: "Bolivia, Plurinational State of bolivia",
    flag: "🇧🇴",
    code: "BO",
    dialCode: "591",
    minPhoneLength: 8,
  },
  { name: "Bosnia and Herzegovina", flag: "🇧🇦", code: "BA", dialCode: "387", minPhoneLength: 8 },
  { name: "Botswana", flag: "🇧🇼", code: "BW", dialCode: "267", minPhoneLength: 7 },
  { name: "Bouvet Island", flag: "🇧🇻", code: "BV", dialCode: "47", minPhoneLength: 8 },
  { name: "Brazil", flag: "🇧🇷", code: "BR", dialCode: "55", minPhoneLength: 10 },
  {
    name: "British Indian Ocean Territory",
    flag: "🇮🇴",
    code: "IO",
    dialCode: "246",
    minPhoneLength: 7,
  },
  { name: "Brunei Darussalam", flag: "🇧🇳", code: "BN", dialCode: "673", minPhoneLength: 7 },
  { name: "Bulgaria", flag: "🇧🇬", code: "BG", dialCode: "359", minPhoneLength: 9 },
  { name: "Burkina Faso", flag: "🇧🇫", code: "BF", dialCode: "226", minPhoneLength: 8 },
  { name: "Burundi", flag: "🇧🇮", code: "BI", dialCode: "257", minPhoneLength: 8 },
  { name: "Cambodia", flag: "🇰🇭", code: "KH", dialCode: "855", minPhoneLength: 9 },
  { name: "Cameroon", flag: "🇨🇲", code: "CM", dialCode: "237", minPhoneLength: 9 },
  { name: "Cape Verde", flag: "🇨🇻", code: "CV", dialCode: "238", minPhoneLength: 7 },
  { name: "Cayman Islands", flag: "🇰🇾", code: "KY", dialCode: "345", minPhoneLength: 10 },
  { name: "Central African Republic", flag: "🇨🇫", code: "CF", dialCode: "236", minPhoneLength: 8 },
  { name: "Chad", flag: "🇹🇩", code: "TD", dialCode: "235", minPhoneLength: 8 },
  { name: "Chile", flag: "🇨🇱", code: "CL", dialCode: "56", minPhoneLength: 9 },
  { name: "China", flag: "🇨🇳", code: "CN", dialCode: "86", minPhoneLength: 11 },
  { name: "Christmas Island", flag: "🇨🇽", code: "CX", dialCode: "61", minPhoneLength: 9 },
  { name: "Cocos (Keeling) Islands", flag: "🇨🇨", code: "CC", dialCode: "61", minPhoneLength: 9 },
  { name: "Colombia", flag: "🇨🇴", code: "CO", dialCode: "57", minPhoneLength: 10 },
  { name: "Comoros", flag: "🇰🇲", code: "KM", dialCode: "269", minPhoneLength: 7 },
  { name: "Congo", flag: "🇨🇬", code: "CG", dialCode: "242", minPhoneLength: 9 },
  {
    name: "Congo, The Democratic Republic of the Congo",
    flag: "🇨🇩",
    code: "CD",
    dialCode: "243",
    minPhoneLength: 9,
  },
  { name: "Cook Islands", flag: "🇨🇰", code: "CK", dialCode: "682", minPhoneLength: 7 },
  { name: "Costa Rica", flag: "🇨🇷", code: "CR", dialCode: "506", minPhoneLength: 8 },
  { name: "Cote d'Ivoire", flag: "🇨🇮", code: "CI", dialCode: "225", minPhoneLength: 8 },
  { name: "Croatia", flag: "🇭🇷", code: "HR", dialCode: "385", minPhoneLength: 9 },
  { name: "Cuba", flag: "🇨🇺", code: "CU", dialCode: "53", minPhoneLength: 8 },
  { name: "Cyprus", flag: "🇨🇾", code: "CY", dialCode: "357", minPhoneLength: 8 },
  { name: "Czech Republic", flag: "🇨🇿", code: "CZ", dialCode: "420", minPhoneLength: 9 },
  { name: "Denmark", flag: "🇩🇰", code: "DK", dialCode: "45", minPhoneLength: 8 },
  { name: "Djibouti", flag: "🇩🇯", code: "DJ", dialCode: "253", minPhoneLength: 8 },
  { name: "Dominica", flag: "🇩🇲", code: "DM", dialCode: "1767", minPhoneLength: 10 },
  { name: "Dominican Republic", flag: "🇩🇴", code: "DO", dialCode: "1849", minPhoneLength: 10 },
  { name: "Ecuador", flag: "🇪🇨", code: "EC", dialCode: "593", minPhoneLength: 9 },
  { name: "Egypt", flag: "🇪🇬", code: "EG", dialCode: "20", minPhoneLength: 10 },
  { name: "El Salvador", flag: "🇸🇻", code: "SV", dialCode: "503", minPhoneLength: 8 },
  { name: "Equatorial Guinea", flag: "🇬🇶", code: "GQ", dialCode: "240", minPhoneLength: 9 },
  { name: "Eritrea", flag: "🇪🇷", code: "ER", dialCode: "291", minPhoneLength: 7 },
  { name: "Estonia", flag: "🇪🇪", code: "EE", dialCode: "372", minPhoneLength: 7 },
  { name: "Ethiopia", flag: "🇪🇹", code: "ET", dialCode: "251", minPhoneLength: 9 },
  {
    name: "Falkland Islands (Malvinas)",
    flag: "🇫🇰",
    code: "FK",
    dialCode: "500",
    minPhoneLength: 5,
  },
  { name: "Faroe Islands", flag: "🇫🇴", code: "FO", dialCode: "298", minPhoneLength: 6 },
  { name: "Fiji", flag: "🇫🇯", code: "FJ", dialCode: "679", minPhoneLength: 7 },
  { name: "Finland", flag: "🇫🇮", code: "FI", dialCode: "358", minPhoneLength: 9 },
  { name: "France", flag: "🇫🇷", code: "FR", dialCode: "33", minPhoneLength: 9 },
  { name: "French Guiana", flag: "🇬🇫", code: "GF", dialCode: "594", minPhoneLength: 9 },
  { name: "French Polynesia", flag: "🇵🇫", code: "PF", dialCode: "689", minPhoneLength: 6 },
  {
    name: "French Southern Territories",
    flag: "🇹🇫",
    code: "TF",
    dialCode: "262",
    minPhoneLength: 6,
  },
  { name: "Gabon", flag: "🇬🇦", code: "GA", dialCode: "241", minPhoneLength: 7 },
  { name: "Gambia", flag: "🇬🇲", code: "GM", dialCode: "220", minPhoneLength: 7 },
  { name: "Georgia", flag: "🇬🇪", code: "GE", dialCode: "995", minPhoneLength: 9 },
  { name: "Germany", flag: "🇩🇪", code: "DE", dialCode: "49", minPhoneLength: 10 },
  { name: "Ghana", flag: "🇬🇭", code: "GH", dialCode: "233", minPhoneLength: 9 },
  { name: "Gibraltar", flag: "🇬🇮", code: "GI", dialCode: "350", minPhoneLength: 8 },
  { name: "Greece", flag: "🇬🇷", code: "GR", dialCode: "30", minPhoneLength: 10 },
  { name: "Greenland", flag: "🇬🇱", code: "GL", dialCode: "299", minPhoneLength: 6 },
  { name: "Grenada", flag: "🇬🇩", code: "GD", dialCode: "1473", minPhoneLength: 10 },
  { name: "Guadeloupe", flag: "🇬🇵", code: "GP", dialCode: "590", minPhoneLength: 9 },
  { name: "Guam", flag: "🇬🇺", code: "GU", dialCode: "1671", minPhoneLength: 10 },
  { name: "Guatemala", flag: "🇬🇹", code: "GT", dialCode: "502", minPhoneLength: 8 },
  { name: "Guernsey", flag: "🇬🇬", code: "GG", dialCode: "44", minPhoneLength: 10 },
  { name: "Guinea", flag: "🇬🇳", code: "GN", dialCode: "224", minPhoneLength: 8 },
  { name: "Guinea-Bissau", flag: "🇬🇼", code: "GW", dialCode: "245", minPhoneLength: 7 },
  { name: "Guyana", flag: "🇬🇾", code: "GY", dialCode: "592", minPhoneLength: 7 },
  { name: "Haiti", flag: "🇭🇹", code: "HT", dialCode: "509", minPhoneLength: 8 },
  {
    name: "Heard Island and Mcdonald Islands",
    flag: "🇭🇲",
    code: "HM",
    dialCode: "672",
    minPhoneLength: 6,
  },
  {
    name: "Holy See (Vatican City State)",
    flag: "🇻🇦",
    code: "VA",
    dialCode: "379",
    minPhoneLength: 6,
  },
  { name: "Honduras", flag: "🇭🇳", code: "HN", dialCode: "504", minPhoneLength: 8 },
  { name: "Hong Kong", flag: "🇭🇰", code: "HK", dialCode: "852", minPhoneLength: 8 },
  { name: "Hungary", flag: "🇭🇺", code: "HU", dialCode: "36", minPhoneLength: 9 },
  { name: "Iceland", flag: "🇮🇸", code: "IS", dialCode: "354", minPhoneLength: 7 },
  { name: "India", flag: "🇮🇳", code: "IN", dialCode: "91", minPhoneLength: 10 },
  { name: "Indonesia", flag: "🇮🇩", code: "ID", dialCode: "62", minPhoneLength: 10 },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    flag: "🇮🇷",
    code: "IR",
    dialCode: "98",
    minPhoneLength: 10,
  },
  { name: "Iraq", flag: "🇮🇶", code: "IQ", dialCode: "964", minPhoneLength: 10 },
  { name: "Ireland", flag: "🇮🇪", code: "IE", dialCode: "353", minPhoneLength: 9 },
  { name: "Isle of Man", flag: "🇮🇲", code: "IM", dialCode: "44", minPhoneLength: 10 },
  { name: "Israel", flag: "🇮🇱", code: "IL", dialCode: "972", minPhoneLength: 9 },
  { name: "Italy", flag: "🇮🇹", code: "IT", dialCode: "39", minPhoneLength: 9 },
  { name: "Jamaica", flag: "🇯🇲", code: "JM", dialCode: "1876", minPhoneLength: 10 },
  { name: "Japan", flag: "🇯🇵", code: "JP", dialCode: "81", minPhoneLength: 10 },
  { name: "Jersey", flag: "🇯🇪", code: "JE", dialCode: "44", minPhoneLength: 10 },
  { name: "Jordan", flag: "🇯🇴", code: "JO", dialCode: "962", minPhoneLength: 9 },
  { name: "Kazakhstan", flag: "🇰🇿", code: "KZ", dialCode: "7", minPhoneLength: 10 },
  { name: "Kenya", flag: "🇰🇪", code: "KE", dialCode: "254", minPhoneLength: 9 },
  { name: "Kiribati", flag: "🇰🇮", code: "KI", dialCode: "686", minPhoneLength: 5 },
  {
    name: "Korea, Democratic People's Republic of Korea",
    flag: "🇰🇵",
    code: "KP",
    dialCode: "850",
    minPhoneLength: 9,
  },
  {
    name: "Korea, Republic of South Korea",
    flag: "🇰🇷",
    code: "KR",
    dialCode: "82",
    minPhoneLength: 9,
  },
  { name: "Kosovo", flag: "🇽🇰", code: "XK", dialCode: "383", minPhoneLength: 8 },
  { name: "Kuwait", flag: "🇰🇼", code: "KW", dialCode: "965", minPhoneLength: 8 },
  { name: "Kyrgyzstan", flag: "🇰🇬", code: "KG", dialCode: "996", minPhoneLength: 9 },
  { name: "Laos", flag: "🇱🇦", code: "LA", dialCode: "856", minPhoneLength: 9 },
  { name: "Latvia", flag: "🇱🇻", code: "LV", dialCode: "371", minPhoneLength: 8 },
  { name: "Lebanon", flag: "🇱🇧", code: "LB", dialCode: "961", minPhoneLength: 8 },
  { name: "Lesotho", flag: "🇱🇸", code: "LS", dialCode: "266", minPhoneLength: 8 },
  { name: "Liberia", flag: "🇱🇷", code: "LR", dialCode: "231", minPhoneLength: 8 },
  { name: "Libyan Arab Jamahiriya", flag: "🇱🇾", code: "LY", dialCode: "218", minPhoneLength: 9 },
  { name: "Liechtenstein", flag: "🇱🇮", code: "LI", dialCode: "423", minPhoneLength: 7 },
  { name: "Lithuania", flag: "🇱🇹", code: "LT", dialCode: "370", minPhoneLength: 8 },
  { name: "Luxembourg", flag: "🇱🇺", code: "LU", dialCode: "352", minPhoneLength: 9 },
  { name: "Macao", flag: "🇲🇴", code: "MO", dialCode: "853", minPhoneLength: 8 },
  { name: "Macedonia", flag: "🇲🇰", code: "MK", dialCode: "389", minPhoneLength: 8 },
  { name: "Madagascar", flag: "🇲🇬", code: "MG", dialCode: "261", minPhoneLength: 9 },
  { name: "Malawi", flag: "🇲🇼", code: "MW", dialCode: "265", minPhoneLength: 9 },
  { name: "Malaysia", flag: "🇲🇾", code: "MY", dialCode: "60", minPhoneLength: 9 },
  { name: "Maldives", flag: "🇲🇻", code: "MV", dialCode: "960", minPhoneLength: 7 },
  { name: "Mali", flag: "🇲🇱", code: "ML", dialCode: "223", minPhoneLength: 8 },
  { name: "Malta", flag: "🇲🇹", code: "MT", dialCode: "356", minPhoneLength: 8 },
  { name: "Marshall Islands", flag: "🇲🇭", code: "MH", dialCode: "692", minPhoneLength: 7 },
  { name: "Martinique", flag: "🇲🇶", code: "MQ", dialCode: "596", minPhoneLength: 9 },
  { name: "Mauritania", flag: "🇲🇷", code: "MR", dialCode: "222", minPhoneLength: 8 },
  { name: "Mauritius", flag: "🇲🇺", code: "MU", dialCode: "230", minPhoneLength: 8 },
  { name: "Mayotte", flag: "🇾🇹", code: "YT", dialCode: "262", minPhoneLength: 9 },
  { name: "Mexico", flag: "🇲🇽", code: "MX", dialCode: "52", minPhoneLength: 10 },
  {
    name: "Micronesia, Federated States of Micronesia",
    flag: "🇫🇲",
    code: "FM",
    dialCode: "691",
    minPhoneLength: 7,
  },
  { name: "Moldova", flag: "🇲🇩", code: "MD", dialCode: "373", minPhoneLength: 8 },
  { name: "Monaco", flag: "🇲🇨", code: "MC", dialCode: "377", minPhoneLength: 9 },
  { name: "Mongolia", flag: "🇲🇳", code: "MN", dialCode: "976", minPhoneLength: 8 },
  { name: "Montenegro", flag: "🇲🇪", code: "ME", dialCode: "382", minPhoneLength: 8 },
  { name: "Montserrat", flag: "🇲🇸", code: "MS", dialCode: "1664", minPhoneLength: 10 },
  { name: "Morocco", flag: "🇲🇦", code: "MA", dialCode: "212", minPhoneLength: 9 },
  { name: "Mozambique", flag: "🇲🇿", code: "MZ", dialCode: "258", minPhoneLength: 9 },
  { name: "Myanmar", flag: "🇲🇲", code: "MM", dialCode: "95", minPhoneLength: 9 },
  { name: "Namibia", flag: "🇳🇦", code: "NA", dialCode: "264", minPhoneLength: 9 },
  { name: "Nauru", flag: "🇳🇷", code: "NR", dialCode: "674", minPhoneLength: 5 },
  { name: "Nepal", flag: "🇳🇵", code: "NP", dialCode: "977", minPhoneLength: 10 },
  { name: "Netherlands", flag: "🇳🇱", code: "NL", dialCode: "31", minPhoneLength: 9 },
  { name: "Netherlands Antilles", flag: "", code: "AN", dialCode: "599", minPhoneLength: 0 },
  { name: "New Caledonia", flag: "🇳🇨", code: "NC", dialCode: "687", minPhoneLength: 6 },
  { name: "New Zealand", flag: "🇳🇿", code: "NZ", dialCode: "64", minPhoneLength: 9 },
  { name: "Nicaragua", flag: "🇳🇮", code: "NI", dialCode: "505", minPhoneLength: 8 },
  { name: "Niger", flag: "🇳🇪", code: "NE", dialCode: "227", minPhoneLength: 8 },
  { name: "Nigeria", flag: "🇳🇬", code: "NG", dialCode: "234", minPhoneLength: 10 },
  { name: "Niue", flag: "🇳🇺", code: "NU", dialCode: "683", minPhoneLength: 4 },
  { name: "Norfolk Island", flag: "🇳🇫", code: "NF", dialCode: "672", minPhoneLength: 6 },
  {
    name: "Northern Mariana Islands",
    flag: "🇲🇵",
    code: "MP",
    dialCode: "1670",
    minPhoneLength: 10,
  },
  { name: "Norway", flag: "🇳🇴", code: "NO", dialCode: "47", minPhoneLength: 8 },
  { name: "Oman", flag: "🇴🇲", code: "OM", dialCode: "968", minPhoneLength: 8 },
  { name: "Pakistan", flag: "🇵🇰", code: "PK", dialCode: "92", minPhoneLength: 10 },
  { name: "Palau", flag: "🇵🇼", code: "PW", dialCode: "680", minPhoneLength: 7 },
  {
    name: "Palestinian Territory, Occupied",
    flag: "🇵🇸",
    code: "PS",
    dialCode: "970",
    minPhoneLength: 9,
  },
  { name: "Panama", flag: "🇵🇦", code: "PA", dialCode: "507", minPhoneLength: 8 },
  { name: "Papua New Guinea", flag: "🇵🇬", code: "PG", dialCode: "675", minPhoneLength: 7 },
  { name: "Paraguay", flag: "🇵🇾", code: "PY", dialCode: "595", minPhoneLength: 9 },
  { name: "Peru", flag: "🇵🇪", code: "PE", dialCode: "51", minPhoneLength: 9 },
  { name: "Philippines", flag: "🇵🇭", code: "PH", dialCode: "63", minPhoneLength: 10 },
  { name: "Pitcairn", flag: "🇵🇳", code: "PN", dialCode: "64", minPhoneLength: 6 },
  { name: "Poland", flag: "🇵🇱", code: "PL", dialCode: "48", minPhoneLength: 9 },
  { name: "Portugal", flag: "🇵🇹", code: "PT", dialCode: "351", minPhoneLength: 9 },
  { name: "Puerto Rico", flag: "🇵🇷", code: "PR", dialCode: "1939", minPhoneLength: 10 },
  { name: "Qatar", flag: "🇶🇦", code: "QA", dialCode: "974", minPhoneLength: 8 },
  { name: "Romania", flag: "🇷🇴", code: "RO", dialCode: "40", minPhoneLength: 10 },
  { name: "Russia", flag: "🇷🇺", code: "RU", dialCode: "7", minPhoneLength: 10 },
  { name: "Rwanda", flag: "🇷🇼", code: "RW", dialCode: "250", minPhoneLength: 9 },
  { name: "Reunion", flag: "🇷🇪", code: "RE", dialCode: "262", minPhoneLength: 9 },
  { name: "Saint Barthelemy", flag: "🇧🇱", code: "BL", dialCode: "590", minPhoneLength: 9 },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    flag: "🇸🇭",
    code: "SH",
    dialCode: "290",
    minPhoneLength: 4,
  },
  { name: "Saint Kitts and Nevis", flag: "🇰🇳", code: "KN", dialCode: "1869", minPhoneLength: 10 },
  { name: "Saint Lucia", flag: "🇱🇨", code: "LC", dialCode: "1758", minPhoneLength: 10 },
  { name: "Saint Martin", flag: "🇲🇫", code: "MF", dialCode: "590", minPhoneLength: 9 },
  { name: "Saint Pierre and Miquelon", flag: "🇵🇲", code: "PM", dialCode: "508", minPhoneLength: 6 },
  {
    name: "Saint Vincent and the Grenadines",
    flag: "🇻🇨",
    code: "VC",
    dialCode: "1784",
    minPhoneLength: 10,
  },
  { name: "Samoa", flag: "🇼🇸", code: "WS", dialCode: "685", minPhoneLength: 5 },
  { name: "San Marino", flag: "🇸🇲", code: "SM", dialCode: "378", minPhoneLength: 9 },
  { name: "Sao Tome and Principe", flag: "🇸🇹", code: "ST", dialCode: "239", minPhoneLength: 7 },
  { name: "Saudi Arabia", flag: "🇸🇦", code: "SA", dialCode: "966", minPhoneLength: 9 },
  { name: "Senegal", flag: "🇸🇳", code: "SN", dialCode: "221", minPhoneLength: 9 },
  { name: "Serbia", flag: "🇷🇸", code: "RS", dialCode: "381", minPhoneLength: 9 },
  { name: "Seychelles", flag: "🇸🇨", code: "SC", dialCode: "248", minPhoneLength: 7 },
  { name: "Sierra Leone", flag: "🇸🇱", code: "SL", dialCode: "232", minPhoneLength: 8 },
  { name: "Singapore", flag: "🇸🇬", code: "SG", dialCode: "65", minPhoneLength: 8 },
  { name: "Slovakia", flag: "🇸🇰", code: "SK", dialCode: "421", minPhoneLength: 9 },
  { name: "Slovenia", flag: "🇸🇮", code: "SI", dialCode: "386", minPhoneLength: 8 },
  { name: "Solomon Islands", flag: "🇸🇧", code: "SB", dialCode: "677", minPhoneLength: 5 },
  { name: "Somalia", flag: "🇸🇴", code: "SO", dialCode: "252", minPhoneLength: 8 },
  { name: "South Africa", flag: "🇿🇦", code: "ZA", dialCode: "27", minPhoneLength: 9 },
  { name: "South Sudan", flag: "🇸🇸", code: "SS", dialCode: "211", minPhoneLength: 9 },
  {
    name: "South Georgia and the South Sandwich Islands",
    flag: "🇬🇸",
    code: "GS",
    dialCode: "500",
    minPhoneLength: 5,
  },
  { name: "Spain", flag: "🇪🇸", code: "ES", dialCode: "34", minPhoneLength: 9 },
  { name: "Sri Lanka", flag: "🇱🇰", code: "LK", dialCode: "94", minPhoneLength: 9 },
  { name: "Sudan", flag: "🇸🇩", code: "SD", dialCode: "249", minPhoneLength: 9 },
  { name: "Suriname", flag: "🇸🇷", code: "SR", dialCode: "597", minPhoneLength: 7 },
  { name: "Svalbard and Jan Mayen", flag: "🇸🇯", code: "SJ", dialCode: "47", minPhoneLength: 8 },
  { name: "Swaziland", flag: "🇸🇿", code: "SZ", dialCode: "268", minPhoneLength: 8 },
  { name: "Sweden", flag: "🇸🇪", code: "SE", dialCode: "46", minPhoneLength: 9 },
  { name: "Switzerland", flag: "🇨🇭", code: "CH", dialCode: "41", minPhoneLength: 9 },
  { name: "Syrian Arab Republic", flag: "🇸🇾", code: "SY", dialCode: "963", minPhoneLength: 9 },
  { name: "Taiwan", flag: "🇹🇼", code: "TW", dialCode: "886", minPhoneLength: 9 },
  { name: "Tajikistan", flag: "🇹🇯", code: "TJ", dialCode: "992", minPhoneLength: 9 },
  {
    name: "Tanzania, United Republic of Tanzania",
    flag: "🇹🇿",
    code: "TZ",
    dialCode: "255",
    minPhoneLength: 9,
  },
  { name: "Thailand", flag: "🇹🇭", code: "TH", dialCode: "66", minPhoneLength: 9 },
  { name: "Timor-Leste", flag: "🇹🇱", code: "TL", dialCode: "670", minPhoneLength: 7 },
  { name: "Togo", flag: "🇹🇬", code: "TG", dialCode: "228", minPhoneLength: 8 },
  { name: "Tokelau", flag: "🇹🇰", code: "TK", dialCode: "690", minPhoneLength: 5 },
  { name: "Tonga", flag: "🇹🇴", code: "TO", dialCode: "676", minPhoneLength: 5 },
  { name: "Trinidad and Tobago", flag: "🇹🇹", code: "TT", dialCode: "1868", minPhoneLength: 10 },
  { name: "Tunisia", flag: "🇹🇳", code: "TN", dialCode: "216", minPhoneLength: 8 },
  { name: "Turkey", flag: "🇹🇷", code: "TR", dialCode: "90", minPhoneLength: 10 },
  { name: "Turkmenistan", flag: "🇹🇲", code: "TM", dialCode: "993", minPhoneLength: 9 },
  {
    name: "Turks and Caicos Islands",
    flag: "🇹🇨",
    code: "TC",
    dialCode: "1649",
    minPhoneLength: 10,
  },
  { name: "Tuvalu", flag: "🇹🇻", code: "TV", dialCode: "688", minPhoneLength: 5 },
  { name: "Uganda", flag: "🇺🇬", code: "UG", dialCode: "256", minPhoneLength: 9 },
  { name: "Ukraine", flag: "🇺🇦", code: "UA", dialCode: "380", minPhoneLength: 9 },
  { name: "United Arab Emirates", flag: "🇦🇪", code: "AE", dialCode: "971", minPhoneLength: 9 },
  { name: "United Kingdom", flag: "🇬🇧", code: "GB", dialCode: "44", minPhoneLength: 10 },
  { name: "Uruguay", flag: "🇺🇾", code: "UY", dialCode: "598", minPhoneLength: 8 },
  { name: "Uzbekistan", flag: "🇺🇿", code: "UZ", dialCode: "998", minPhoneLength: 9 },
  { name: "Vanuatu", flag: "🇻🇺", code: "VU", dialCode: "678", minPhoneLength: 5 },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    flag: "🇻🇪",
    code: "VE",
    dialCode: "58",
    minPhoneLength: 10,
  },
  { name: "Vietnam", flag: "🇻🇳", code: "VN", dialCode: "84", minPhoneLength: 9 },
  { name: "Virgin Islands, British", flag: "🇻🇬", code: "VG", dialCode: "1284", minPhoneLength: 10 },
  { name: "Virgin Islands, U.S.", flag: "🇻🇮", code: "VI", dialCode: "1340", minPhoneLength: 10 },
  { name: "Wallis and Futuna", flag: "🇼🇫", code: "WF", dialCode: "681", minPhoneLength: 6 },
  { name: "Yemen", flag: "🇾🇪", code: "YE", dialCode: "967", minPhoneLength: 9 },
  { name: "Zambia", flag: "🇿🇲", code: "ZM", dialCode: "260", minPhoneLength: 9 },
  { name: "Zimbabwe", flag: "🇿🇼", code: "ZW", dialCode: "263", minPhoneLength: 9 },
];

// create a code to country map
export const COUNTRY_CODE_TO_COUNTRY: Record<string, (typeof COUNTRIES)[number]> = COUNTRIES.reduce(
  (countryCodeToCountryMap, country) => {
    countryCodeToCountryMap[country.code] = country;

    return countryCodeToCountryMap;
  },
  {} as Record<string, (typeof COUNTRIES)[number]>
);
